// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage} from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCN6IOIVi0p-lKSeug1uwR3JzErCsCRP6M",
  authDomain: "fashionforward-6d411.firebaseapp.com",
  projectId: "fashionforward-6d411",
  storageBucket: "fashionforward-6d411.appspot.com",
  messagingSenderId: "323131624907",
  appId: "1:323131624907:web:174f06f139a48d8845fa4e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage();